import { useEffect } from "react";

const SITE = "https://morningsundeyter.com";
const OG_IMAGE = `${SITE}/og-image.jpg`;

function ensureMeta(selector, create) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  return el;
}

/**
 * useSeo — sets document.title, meta description, canonical URL and OG tags per page.
 * Pass an absolute or root-relative `path` (e.g. "/dream-numbers").
 */
export default function useSeo({ title, description, path = "/" }) {
  useEffect(() => {
    if (title) document.title = title;
    const url = `${SITE}${path.startsWith("/") ? path : `/${path}`}`;

    if (description) {
      const meta = ensureMeta('meta[name="description"]', () => {
        const m = document.createElement("meta");
        m.setAttribute("name", "description");
        return m;
      });
      meta.setAttribute("content", description);
    }

    const canonical = ensureMeta('link[rel="canonical"]', () => {
      const l = document.createElement("link");
      l.setAttribute("rel", "canonical");
      return l;
    });
    canonical.setAttribute("href", url);

    const setProp = (property, content) => {
      const m = ensureMeta(`meta[property="${property}"]`, () => {
        const el = document.createElement("meta");
        el.setAttribute("property", property);
        return el;
      });
      m.setAttribute("content", content);
    };
    if (title) setProp("og:title", title);
    if (description) setProp("og:description", description);
    setProp("og:url", url);
    setProp("og:image", OG_IMAGE);
    setProp("og:image:width", "1200");
    setProp("og:image:height", "630");

    const setName = (name, content) => {
      const m = ensureMeta(`meta[name="${name}"]`, () => {
        const el = document.createElement("meta");
        el.setAttribute("name", name);
        return el;
      });
      m.setAttribute("content", content);
    };
    if (title) setName("twitter:title", title);
    if (description) setName("twitter:description", description);
    setName("twitter:url", url);
    setName("twitter:image", OG_IMAGE);
    setName("twitter:card", "summary_large_image");
  }, [title, description, path]);
}
